import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cx from 'clsx';
import { getInternalTheme } from './getInternalTheme';
import * as styles from '../styles.css';
import { ETheme } from '../types';

/** Возвращает константы для управления темой ловушки. Существует 4 разных варианта тем */
export var useTheming = function useTheming(variant, className) {
  return React.useMemo(function () {
    var _cx;
    var _theme = getInternalTheme(variant);
    var containerClassname = cx(className, styles['container'], styles["background_".concat(variant)], (_cx = {}, _defineProperty(_cx, styles['light'], _theme === ETheme.Light), _defineProperty(_cx, styles['dark'], _theme === ETheme.Dark), _cx));
    var buttonTheme = _theme === ETheme.Light ? 'fill_white_primary' : 'fill_primary';
    return {
      containerClassname: containerClassname,
      buttonTheme: buttonTheme
    };
  }, [className, variant]);
};